import React from 'react';
import ReactDOM from 'react-dom';

import ZendeskSupportButton from 'web-ui-kit/buttons/ZendeskSupportButton';

/**
 * Portal Wrapper Around the Zendesk Help Button
 */
export default React.forwardRef(function PortaledZendeskButton (props, ref) {
  return ReactDOM.createPortal(
    <ZendeskSupportButton {...props} ref={ref} />, document.body);
});
